import React, { FC, useEffect, useState } from 'react';
import withFallback from '../../components/image-with-fallback';
import cn from 'classnames';

type Props = {
  images: string[];
  preferredImage?: string;
};

export const ImageGallery: FC<Props> = ({ images, preferredImage }) => {
  const [selectedImage, setSelectedImage] = useState<string>(images[0]);

  useEffect(() => {
    if (preferredImage) {
      setSelectedImage(preferredImage);
    }
  }, [preferredImage, images]);

  return (
    <div>
      <div className="overflow-x-hidden flex justify-center">
        <img
          className="Detail-Main-Image w-full mt-20 mb-10 md:mt-none object-cover"
          src={withFallback(selectedImage, '500x')}
          alt="Product"
        />
      </div>
      <div className="flex flex-wrap">
        {images.length > 1 &&
          images.map((image) => (
            <div
              key={image}
              onClick={() => setSelectedImage(image)}
              className={cn(
                `border max-w-50  overflow-x-hidden
          cursor-pointer flex justify-center w-fit mb-10 mr-10`,
                image === selectedImage && 'border-grey-2',
                image !== selectedImage && 'border-white',
              )}
            >
              <img
                className="w-auto h-50 cursor-pointer"
                src={withFallback(image, '100x')}
                alt="Product"
              />
            </div>
          ))}
      </div>
    </div>
  );
};
